import React from "react";

// const Loading = () => <div className="loading-spinner" />;
const Loading = () => <div className="loading" />;

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js